/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BodyMeasurementViewFilter } from './BodyMeasurementViewFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type BodyMeasurementViewRequest = {
    filter?: BodyMeasurementViewFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: BodyMeasurementViewRequest.exposeType;
}

export namespace BodyMeasurementViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
